import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "../../components/forms/ConfirmForm";
import {cancelDeleteCustomer} from "../../actions/AccountApiActions";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";


class DeleteCustomerFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(_values) {
    return this.props.deleteCustomer({customerId: this.props.customerId})
      .then((response) => {
        if (response.data.deleteCustomer.errors.length <= 0) {
          this.handleCancel();
        } else {
          let errors = createValidationErrors(response.data.deleteCustomer.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });
  }

  handleCancel() {
    this.props.cancelDeleteCustomer();
  }

  render() {
    return (
      <Form
        message="This will reset the customer's payment method, remove his credentials from auth0, and purge as much information as possible in the databse to comply with GDPR without losing important information like subscription history or invoices."
        submitLabel="Delete Customer"
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        errors={this.state.errors}
        />
    )
  }
}

const DELETE_CUSTOMER = gql`
  mutation deleteCustomer($customerId: ID!) {
    deleteCustomer(customerId: $customerId) {
      errors { key message }
    }
  }
`;


const withQueries = compose(
  graphql(DELETE_CUSTOMER, {
    props: ({ mutate }) => ({
      deleteCustomer: (data) => mutate({
        variables: data
      })
    })
  })
);

export default connect(null, {cancelDeleteCustomer})(withQueries(DeleteCustomerFormContainer));